
export const ROUTE_ABILITY_META = {
  'operational-users': { action: 'read', subject: 'Users' },
  'operational-users-user_id': { action: 'read', subject: 'Users' },
  'operational-fee': { action: 'read', subject: 'Fee' },
  'operational-kyc': { action: 'read', subject: 'Kyc' },
  'operational-kyb': { action: 'read', subject: 'Kyb' },
  'operational-merchant-api': { action: 'read', subject: 'MerchantApi' },
  'operational-transactions': { action: 'read', subject: 'Transactions' },
  'operational-transactions-trade_no': { action: 'read', subject: 'Transactions' },
  'operational-error-cases': { action: 'read', subject: 'Transactions' },
  'operational-return-required': { action: 'read', subject: 'Transactions' },
  'operational-funds-freeze': { action: 'read', subject: 'FundsFreeze' },
  'funds-freeze': { action: 'read', subject: 'FundsFreeze' },
  'freeze-history': { action: 'read', subject: 'FreezeHistory' },
  'fee-history': { action: 'read', subject: 'FeeHistory' },
  'operational-limits-list': { action: 'read', subject: 'LimitsList' },
  'operational-pix-keys': { action: 'read', subject: 'PixKeys' },
  'operational-pix-key-controls': { action: 'manage', subject: 'PixKeyControls' },
  'operational-med': { action: 'read', subject: 'Med' },
  'operational-med-case_id': { action: 'read', subject: 'Med' },
  'operational-infractions': { action: 'read', subject: 'Med' },
  'operational-infractions-tab': {
    action: 'read',
    subject: 'Med',
    navActiveLink: 'operational-infractions',
  },
  'access-control': { action: 'read', subject: 'AccessControl' },
  apix: { action: 'read', subject: 'Apix' },
  'operational-logs': { action: 'read', subject: 'Logs' },
  'logs-pix-key-logs': { action: 'read', subject: 'Logs' },
  log: { action: 'read', subject: 'Logs' },
}
